<template>
  <div class="registerform__step step__three">
    <div class="step__content">
      <div class="progress-bar" v-if="showPagination">
        <Progressbar
            :active="3"
            @updateStep="$emit('updateStep', $event)"/>
      </div>
      <div class="step__form">
        <div class="form__headline" :class="{ '-error': errorAvailabilty }" v-if="stepOneDecision === 2">
          <h4 class="-color-alpha">Termin für Software Vorstellung:</h4>
          <p class="-color-error" v-if="errorAvailabilty">Leider wurde Ihr Termin in der Zwischenzeit vergeben.</p>
          <p class="-color-error" v-if="errorAvailabilty && availableSlots.length">Bitte suchen Sie sich einen neuen aus.</p>
          <p :class="{ '-color-error': errorAvailabilty }" v-if="!availableSlots.length">Derzeit sind keine Termine zur Auswahl verfügbar. Wir werden Sie schnellstmöglich kontaktieren um mit Ihnen einen persönlichen Termin zu vereinbaren. Bitte füllen Sie dazu die folgenden Felder aus.</p>
        </div>
        <div class="field__wrap -smaller-spacing" v-if="stepOneDecision === 2 && availableSlots.length">
          <div class="col">
            <CmInputTypeSelect
                identifier="selectedSlot"
                label="Verfügbare Termine"
                :options="availableSlots.map((slot, index) => ({ label: $moment(slot.begin).format('HH:mm') + ' - ' + $moment(slot.end).format('HH:mm DD.MM.YYYY'), value: index }))"
                v-model="selectedSlot"
                :error="error && !appointmentIsValid"/>
          </div>
        </div>
        <div class="field__wrap -smaller-spacing" v-if="stepOneDecision === 2 && availableSlots.length">
          <div class="col">
            <Checkbox
                identifier="call"
                v-model="call"
                @updateValue="call = $event"
                :error="error && !appointmentIsValid"><span>Es ist kein passender Termin dabei. Ich möchte angerufen werden, um einen Termin auszumachen.</span>
            </Checkbox>
          </div>
        </div>
        <div class="form__headline">
          <h4>Ihre Kontaktdaten:</h4>
        </div>
        <div class="form__form">
          <div class="field__wrap field__wrap--two-col -smaller-spacing">
            <div class="col col-one">
              <CmInputTypeSelect
                  label="Anrede"
                  :bold="true"
                  identifier="salutation"
                  v-model="salutation"
                  :options="[{ label: 'Herr', value: 'Herr' }, { label: 'Frau', value: 'Frau' }]"
                  :error="error && salutationIsMissing"/>
            </div>
          </div>
          <div class="field__wrap field__wrap--two-col -smaller-spacing">
            <div class="col col-one">
              <TextInput
                  label="Vorname"
                  :bold="true"
                  identifier="firstname"
                  v-model="firstname"
                  :error="error && firstnameIsMissing"/>
            </div>
            <div class="col col-two">
              <TextInput
                  label="Nachname"
                  :bold="true"
                  identifier="lastname"
                  v-model="lastname"
                  :error="error && lastnameIsMissing"/>
            </div>
          </div>
          <div class="field__wrap field__wrap--two-col -smaller-spacing" v-if="stepOneDecision !== 3">
            <div class="col col-one">
              <TextInput
                  label="Firma"
                  :bold="true"
                  identifier="company"
                  v-model="company"
                  :error="false"/>
            </div>
          </div>
          <div class="field__wrap field__wrap--two-col -smaller-spacing" v-if="stepOneDecision !== 3">
            <div class="col col-one">
              <TextInput
                  label="PLZ"
                  :bold="true"
                  identifier="zip"
                  v-model="zip"
                  :error="false"/>
            </div>
            <div class="col col-two">
              <TextInput
                  label="Ort"
                  :bold="true"
                  identifier="city"
                  v-model="city"
                  :error="false"/>
            </div>
          </div>
          <div class="field__wrap field__wrap--two-col -smaller-spacing">
            <div class="col col-one">
              <TextInput
                  label="E-Mail"
                  :bold="true"
                  identifier="email"
                  v-model="email"
                  :error="error && emailIsMissing"/>
            </div>
            <div class="col col-two">
              <TextInput
                  label="Telefonnummer"
                  :bold="true"
                  identifier="phone"
                  v-model="phone"
                  :error="error && phoneIsMissing"/>
            </div>
          </div>
          <div class="field__wrap field__wrap--one-col -smaller-spacing">
            <div class="col">
              <TextInput
                  label="Wann sind Sie am besten erreichbar?"
                  :bold="true"
                  identifier="availability"
                  v-model="availability"
                  :error="error && availabilityIsMissing"></TextInput>
            </div>
          </div>
          <div class="field__wrap -smaller-spacing -privacy">
            <div class="col">
              <Checkbox
                  identifier="privacy"
                  v-model="privacy"
                  @updateValue="privacy = $event"
                  :error="error && privacyIsMissing"><span>Mit Setzen des Hakens erkläre ich mich einverstanden, dass die von mir erhobenen Daten für die Bearbeitung meiner Anfrage elektronisch erhoben und gespeichert werden. Diese Einwilligung kann jederzeit mit einer Nachricht an uns widerrufen werden. Weitere Informationen entnehmen Sie der <a
                  :href="privacyPage" target="_blank">Datenschutzerklärung</a>.</span></Checkbox>
            </div>
          </div>
        </div>
        <div class="form__action">
          <div class="-btn-alpha" @click="nextStep()"><span>Absenden</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Progressbar from '../Progressbar.vue'
import TextInput from '../form/CmInputTypeText.vue'
import Checkbox from '../form/CmInputTypeCheckbox.vue'
import CmInputTypeSelect from "@/components/form/CmInputTypeSelect";
import axios from "axios";

export default {
  name: 'StepThree',
  data() {
    return {
      symfonyApiBase: window.tx_rental.symfonyApiBase,
      error: false,
      errorAvailabilty: false,
      availableSlots: []
    }
  },
  props: {
    registerform: {
      type: Object,
      default: () => {
      }
    },
    stepOneDecision: {
      type: Number,
      default: null
    },
    privacyPage: {
      type: String,
      default: ''
    },
    showPagination: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Progressbar,
    CmInputTypeSelect,
    TextInput,
    Checkbox
  },
  computed: {
    call: {
      get: function () {
        return this.registerform.call
      },
      set: function (val) {
        this.$emit('updateForm', {call: val})
      }
    },
    selectedSlot: {
      get: function () {
        return this.registerform.selectedSlot.index
      },
      set: function (slotIndex) {
        if (!slotIndex) {
          this.$emit('updateForm', { selectedSlot: { index: null, from: null, to: null } })
        } else {
          this.$emit('updateForm', {
            selectedSlot: {
              index: slotIndex,
              from: this.availableSlots[slotIndex].begin,
              to: this.availableSlots[slotIndex].end,
              user: this.availableSlots[slotIndex].user
            }
          })
        }
      }
    },
    salutation: {
      get: function () {
        return this.registerform.salutation
      },
      set: function (val) {
        this.$emit('updateForm', { salutation: val })
      }
    },
    salutationIsMissing: function () {
      return !this.salutation
    },
    firstname: {
      get: function () {
        return this.registerform.firstname
      },
      set: function (val) {
        this.$emit('updateForm', { firstname: val })
      }
    },
    firstnameIsMissing: function () {
      return !this.firstname
    },
    lastname: {
      get: function () {
        return this.registerform.lastname
      },
      set: function (val) {
        this.$emit('updateForm', { lastname: val })
      }
    },
    lastnameIsMissing: function () {
      return !this.lastname
    },
    company: {
      get: function () {
        return this.registerform.company
      },
      set: function (val) {
        this.$emit('updateForm', { company: val })
      }
    },
    zip: {
      get: function () {
        return this.registerform.zip
      },
      set: function (val) {
        this.$emit('updateForm', { zip: val })
      }
    },
    city: {
      get: function () {
        return this.registerform.city
      },
      set: function (val) {
        this.$emit('updateForm', { city: val })
      }
    },
    email: {
      get: function () {
        return this.registerform.email
      },
      set: function (val) {
        this.$emit('updateForm', { email: val })
      }
    },
    emailIsMissing: function () {
      return !this.email
    },
    phone: {
      get: function () {
        return this.registerform.phone
      },
      set: function (val) {
        this.$emit('updateForm', { phone: val })
      }
    },
    phoneIsMissing: function () {
      return !this.phone
    },
    availability: {
      get: function () {
        return this.registerform.availability
      },
      set: function (val) {
        this.$emit('updateForm', { availability: val })
      }
    },
    availabilityIsMissing: function () {
      return !this.availability
    },
    privacy: {
      get: function () {
        return this.registerform.privacy
      },
      set: function (val) {
        this.$emit('updateForm', { privacy: val })
      }
    },
    privacyIsMissing: function () {
      return !this.privacy
    },
    appointmentIsValid: function () {
      return (!this.call && this.selectedSlot !== null) || (this.call && this.selectedSlot === null)
    },
    requiredFieldsFilled: function () {
      return !this.salutationIsMissing && !this.firstnameIsMissing && !this.lastnameIsMissing && !this.emailIsMissing && !this.phoneIsMissing && !this.availabilityIsMissing && !this.privacyIsMissing
    }
  },
  methods: {
    nextStep: function () {
      if (((this.stepOneDecision !== 2) || (this.stepOneDecision === 2 && this.appointmentIsValid)) && this.requiredFieldsFilled) {
        if (this.stepOneDecision === 2 && this.selectedSlot !== null) {
          const self = this
          self.$emit('setLoading', true)
          new Promise(this.requestAvailabilityCheck)
              .then(response => {
                if (response.available) {
                  self.error = false
                  self.errorAvailabilty = false
                  self.$emit('setLoading', false)
                  self.$emit('handleRequest')
                } else {
                  self.selectedSlot = null
                  self.error = true
                  self.errorAvailabilty = true
                  self.scrollToFirstError()
                  self.$emit('setLoading', false)
                  self.getAvailableSlots()
                }
              }).catch(reason => {
                console.log(reason)
              })
        } else {
          this.error = false
          this.$emit('handleRequest')
        }
      } else {
        this.error = true
        this.scrollToFirstError()
      }
    },
    scrollToFirstError () {
      window.setTimeout(() => {
        window.scrollTo(0, document.querySelectorAll('.form__headline.-error, .fields__field.-error')[0].offsetTop)
      }, 1)
    },
    getAvailableSlots() {
      const self = this
      self.$emit('setLoading', true)
      self.selectedSlot = null
      new Promise(self.requestAvailableSlots)
          .then(slots => {
            self.availableSlots = slots
            self.call = self.stepOneDecision === 2 && !slots.length ? 1 : 0
            self.$emit('setLoading', false)
          })
          .catch(reason => {
            console.log(reason)
          })
    },
    async requestAvailableSlots(resolve, reject) {
      try {
        const self = this
        const url = new URL(self.symfonyApiBase + '/api/availability/slots')
        url.searchParams.set('license', '1')
        const response = await axios.get(url.href)
        resolve(response.data)
      } catch (e) {
        reject(e)
      }
    },
    async requestAvailabilityCheck(resolve, reject) {
      try {
        const response = await axios.post(
            this.symfonyApiBase + '/api/availability/check',
            {
              license: 1,
              selectedSlotFrom: this.availableSlots[this.selectedSlot].begin,
              selectedSlotTo: this.availableSlots[this.selectedSlot].end,
              selectedSlotUser: this.availableSlots[this.selectedSlot].user
            }
        )
        resolve(response.data)
      } catch (e) {
        reject(e)
      }
    }
  },
  created() {
    this.getAvailableSlots()
  }
}
</script>
